import { format as dateFormat, utcToZonedTime } from 'date-fns-tz';
import { ITimeZone } from 'src/types/OrderHistory';

export function getFormattedTimezoneFromObject(
  utcDate: string,
  timeZone: ITimeZone,
  dateFormatString: string
): string {
  return getTimezoneFormattedDate(utcDate, timeZone?.id, dateFormatString);
}

// see https://github.com/marnusw/date-fns-tz#date-fns-tz for more info
export function getTimezoneFormattedDate(
  utcDate: string,
  timezoneString: string,
  dateFormatString: string
): string {
  if (!utcDate) {
    return '';
  }

  const timeZoneId = timezoneString || getBrowserTimeZone();

  const zonedTime = utcToZonedTime(utcDate, timeZoneId);

  return dateFormat(zonedTime, `${dateFormatString} zzz`, {
    timeZone: timeZoneId,
  });
}

export const formatISOString = (
  isoString: string,
  formatString: string
): string => {
  if (!isoString) {
    return '';
  }

  return dateFormat(Date.parse(isoString), formatString);
};

export function getBrowserTimeZone(): string {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return userTimezone;
}
